import { render, staticRenderFns } from "./newFive.vue?vue&type=template&id=30422415&scoped=true&"
import script from "./newFive.vue?vue&type=script&lang=js&"
export * from "./newFive.vue?vue&type=script&lang=js&"
import style0 from "./newFive.vue?vue&type=style&index=0&id=30422415&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30422415",
  null
  
)

export default component.exports